import React from "react";

export default function PageNotFound() {
  return (
    <div className="flex-center" style={{ height: "calc(100vh - 80px)" }}>
      <h1 className="semi-bold" style={{letterSpacing: '2px'}}>No Match Found!</h1>
    </div>
  );
}
